import { observer } from 'mobx-react-lite';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ColumnsMeta, GdListHeader } from '../../../components/GdListHeader';
import { useRootStore } from '../../../context/storeContext';
import { SortDirection } from '../../../types/commonTypes';

export const GlossaryListHeader = observer(() => {
  const { t } = useTranslation();
  const { glossaryStore } = useRootStore();

  const sortingHandler = useCallback(
    (order: SortDirection, field: string) => {
      glossaryStore.sortWords(order, field);
    },
    [glossaryStore]
  );

  const columns: ColumnsMeta = useMemo(
    () => ({
      word: {
        title: t('glossary:ListHeader:wordLbl'),
        colspan: 4,
        leftPadding: 24,
        sortingHandler,
        direction: SortDirection.Asc,
      },
      text: {
        title: t('glossary:ListHeader:textLbl'),
        colspan: 7,
        sortingHandler,
        direction: SortDirection.Asc,
      },
      labelLink: {
        title: t('glossary:ListHeader:labelLinkLbl'),
        colspan: 5,
        sortingHandler,
        direction: SortDirection.Asc,
      },
      link: {
        title: t('glossary:ListHeader:linkLbl'),
        colspan: 5,
        sortingHandler,
        direction: SortDirection.Asc,
      },
      actions: {
        title: '',
        colspan: 3,
      },
    }),
    [sortingHandler, t]
  );

  return <GdListHeader activeSortField={'word'} columns={columns} />;
});
